import { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import { formatDate } from "@utils/util";
import { useTranslation } from "react-i18next";

const MARQUEE_PAUSE_MS = 900;
const MARQUEE_SCROLL_PX_PER_SEC = 102;
const MARQUEE_SCROLL_MIN_MS = 400;

export default memo(function CardEpg({
  item,
  isActive,
  onClick,
  currentEpg,
  hasArchive,
  nextEpg,
  type,
}) {
  const { t } = useTranslation();
  const titleInnerRef = useRef(null);
  const marqueeAnimRef = useRef(null);
  const [marqueePx, setMarqueePx] = useState(0);

  useLayoutEffect(() => {
    if (!isActive) {
      setMarqueePx(0);
      return;
    }
    const el = titleInnerRef.current;
    if (!el) return;
    const overflow = el.scrollWidth - el.clientWidth;
    setMarqueePx(overflow > 1 ? overflow : 0);
  }, [isActive, item.title]);

  useEffect(() => {
    marqueeAnimRef.current?.cancel();
    marqueeAnimRef.current = null;
    const el = titleInnerRef.current;
    if (!el) return;
    if (!isActive || marqueePx <= 0) {
      el.style.transform = "";
      return;
    }
    if (typeof el.animate !== "function") return;
    const scrollMs = Math.max(
      MARQUEE_SCROLL_MIN_MS,
      (marqueePx / MARQUEE_SCROLL_PX_PER_SEC) * 1000,
    );
    const total = 2 * MARQUEE_PAUSE_MS + scrollMs;
    const at = (ms) => ms / total;
    const anim = el.animate(
      [
        { transform: "translateX(0)", offset: 0 },
        { transform: "translateX(0)", offset: at(MARQUEE_PAUSE_MS) },
        {
          transform: `translateX(-${marqueePx}px)`,
          offset: at(MARQUEE_PAUSE_MS + scrollMs),
        },
        { transform: `translateX(-${marqueePx}px)`, offset: 1 },
      ],
      { duration: total, iterations: Infinity, fill: "both" },
    );
    marqueeAnimRef.current = anim;
    return () => {
      anim.cancel();
      marqueeAnimRef.current = null;
      el.style.transform = "";
    };
  }, [isActive, marqueePx]);

  return (
    <div
      className={`card-epg${isActive ? " active" : ""}`}
      onClick={hasArchive && type == "past" ? () => onClick(item) : () => {}}
    >
      <div className={`square ${type} ${hasArchive}${nextEpg ? " next" : ""}`}>
        {type == "past" ? (
          hasArchive ? (
            <span>{t("Rec")}</span>
          ) : (
            <span>{t("N/A")}</span>
          )
        ) : type == "now" ? (
          <span>{t("Now")}</span>
        ) : type == "future" ? (
          nextEpg ? (
            <span>{t("Next")}</span>
          ) : (
            <span>{t("N/A")}</span>
          )
        ) : null}
      </div>
      <p className="date_time">
        {formatDate(new Date(item.start_ut * 1000), "dd/MM")} |{" "}
        {formatDate(new Date(item.start_ut * 1000), "hh:mm aaa")} {" - "}
        {formatDate(new Date(item.stop_ut * 1000), "hh:mm aaa")}
      </p>
      <div className="title-wrap">
        <span
          ref={titleInnerRef}
          className={`title-inner${isActive && marqueePx > 0 ? " title-inner--marquee" : ""}`}
        >
          {item.title}
        </span>
      </div>
    </div>
  );
});
